module.exports = __webpack_public_path__ + "static/media/1020594.a094d49f.png";